/*
 * Information notification that can be customized with content
 */
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {semanticColor} from "@khanacademy/wonder-blocks-tokens";

import {BaseToastNotification} from "../base-toast-notification.tsx";

export const InfoNotification = ({content}: {content: React.ReactNode}) => {
    return (
        <BaseToastNotification style={styles.toast}>
            {content}
        </BaseToastNotification>
    );
};

const styles = StyleSheet.create({
    toast: {
        backgroundColor: semanticColor.core.background.instructive.default,
        color: semanticColor.core.foreground.knockout.default,
    },
});
